import React, { useState, useEffect } from "react";
import HeroComponent from "../../Components/LandingSection/HeroComponent/HeroComponent";
import AutomateTab from "../../Components/LandingSection/AutomateTab/AutomateTab";
import NextLevelFeatures from "../../Components/LandingSection/NextLevelFeatures/NextLevelFeatures";
import SliderSection from "../../Components/LandingSection/SliderSection/SliderSection";
import YourAdvantage from "../../Components/LandingSection/YourAdvantage/YourAdvantage";
import ClientsSay from "../../Components/LandingSection/ClientsSay/ClientsSay";
import FaqSection from "../../Components/LandingSection/FaqSection/FaqSection";
import CustomerExperience from "../../Components/LandingSection/CustomerExperience/CustomerExperience";
import MarqueeSlider from "../../Components/LandingSection/MarqueeSlider/MarqueeSlider";
import ThreeStrip from "../../Components/ThreeStrip/ThreeStrip";
import styles from "../LandingPage/LandingPage.module.css";
import WhyRexpt from "../../Components/HomePageCTA.js/HomeCta";
const LandingPage = ({
  hero,
  banner,
  rexptWorkFlow,
  HomeFeature,
  testimonialdata,
  fetchYourAdvantagedata,
  fetchNMTestimonialdata,
  fetchFaq,
  rexptSectionPage,
}) => {
  const [scrollPercent, setScrollPercent] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const percent = (scrollTop / docHeight) * 100;
      setScrollPercent(percent);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  let wrapperClass = "";
  if (scrollPercent < 7) {
    wrapperClass = styles.bottomView;
  } else if (scrollPercent >= 7 && scrollPercent < 10) {
    wrapperClass = styles.slideUp;
  } else {
    wrapperClass = styles.normalFlow;
  }

  return (
    <>
      {hero?.enabled && <HeroComponent hero={hero} />}
      <div className={`${styles.threeStripWrapper} ${wrapperClass}`}>
        <ThreeStrip />
      </div>

      {banner?.enabled && <MarqueeSlider banner={banner} />}
      {rexptWorkFlow?.enabled && <AutomateTab rexptWorkFlow={rexptWorkFlow} />}
      {HomeFeature?.enabled && <NextLevelFeatures HomeFeature={HomeFeature} />}
      {testimonialdata?.enabled && (
        <SliderSection testimonialdata={testimonialdata} />
      )}
      {fetchYourAdvantagedata?.enabled && (
        <YourAdvantage fetchYourAdvantagedata={fetchYourAdvantagedata} />
      )}
      {fetchNMTestimonialdata?.enabled && (
        <ClientsSay fetchNMTestimonialdata={fetchNMTestimonialdata} />
      )}
      {fetchFaq?.enabled && <FaqSection fetchFaq={fetchFaq} />}
      <WhyRexpt rexptSectionPage={rexptSectionPage} />
      {/* <CustomerExperience /> */}
    </>
  );
};

export default LandingPage;
